module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "side-bar",
    class: {
      'show': _vm.show
    },
    style: ('width:' + _vm.width + 'vw')
  }, [_c('div', {
    staticClass: "side-bar-close iconfont icon-times",
    on: {
      "click": _vm.hideSideBar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "side-bar-title"
  }, [_vm._v("\n      " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "side-bar-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "side-bar-footer"
  }, [_vm._t("footer")], 2)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7d0ee712", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d0ee712"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/element/sideBar.vue
// module id = 2855
// module chunks = 0